<template>
  <div class="wrapper">
    <swiper
      :slidesPerView="slidesPerView"
      :loop="loop"
      :autoplay="autoplay"
      :pagination="pagination"
      :navigation="swiperOptions.navigation"
      :centeredSlides="centeredSlides"
      :slidesPerGroup="slidesPerGroup"
      @swiper="onSwiper"
      @slideChange="onSlideChange"
    >
      <swiper-slide v-for="(item, index) in imgs" :key="index">
        <div class="swiper-item" :class="isPadding ? 'item' : ''">
          <img class="swiper-img" :src="item" alt="" />
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import SwiperCore, {
  Autoplay,
  Pagination,
  EffectCoverflow,
  Navigation
} from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/vue'
import 'swiper/swiper.scss'

import { reactive, onMounted } from 'vue'
SwiperCore.use([Autoplay, Pagination, EffectCoverflow, Navigation])
export default {
  props: {
    imgs: Array,
    slidesPerView: Number,
    autoplay: Object,
    loop: Boolean,
    navigation: Object,
    pagination: Object,
    centeredSlides: Boolean,
    slidesPerGroup: Number,
    isPadding: Boolean
  },
  setup () {
    const swiperOptions = reactive({
      autoplay: {
        disableOnInteraction: false, // 鼠标滑动后不自动播放
        delay: 1500 // 1.5秒切换一次
      },
      speed: 500, // 切换过渡速度
      loop: true,
      slidesPerView: '3', // 解决最后一张切换到第一张中间的空白
      centeredSlides: true, // 设置slide居中
      spaceBetween: 20,
      coverflowEffect: {
        // rotate: 0, //slide做3d旋转时Y轴的旋转角度。默认50。
        stretch: 50, // 每个slide之间的拉伸值（距离），越大slide靠得越紧。 默认0。
        depth: 100, // slide的位置深度。值越大z轴距离越远，看起来越小。 默认100。
        modifier: 1 // depth和rotate和stretch的倍率，相当于depth*modifier、rotate*modifier、stretch*modifier，值越大这三个参数的效果越明显。默认1。
        // slideShadows: false, //开启slide阴影。默认 true。
      },
      navigation: {
        nextElRef: '.swiper-button-next swiper-button-black',
        prevElRef: '.swiper-button-prev swiper-button-black'
      },
      pagination: {
        clickable: true
      }
    })

    const onSwiper = () => {}
    const onSlideChange = () => {}
    onMounted(() => {})
    return {
      onSwiper,
      onSlideChange,
      swiperOptions
    }
  },
  components: {
    Swiper,
    SwiperSlide
  }
}
</script>

<style lang="scss">
.swiper-item {
  transition: all 0.3s ease 0s;
  &:hover {
    transform: scale(1.01);
  }
}
.item2 {
  width: 344px;
  height: 212px;
  background: url(../assets/images/roll2.png);
  background-position: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .tag_btn {
    width: 120px;
    height: 36px;
    background: linear-gradient(90deg, #ff5e41 0%, #fc4353 100%) no-repeat;
    opacity: 1;
    border-radius: 18px;
    text-align: center;
    line-height: 36px;
    color: white;
    font-size: 18px;
    margin: 16px 0 0 0;
    cursor: pointer;
  }
  .tag_title {
    font-size: 34px;
    em {
      color: red;
    }
  }
}
</style>
